export default __webpack_public_path__ + "src/images/tip_mask-172d7b.png";